import { MultipleModalConfigs } from "features/shared/types/modal";

const ACCESS_MODAL_CONFIG: MultipleModalConfigs = {
    ADD: {
        headingText: "New User",
        submitBtnText: "Add",
    },
    UPDATE: {
        headingText: "Update User",
        submitBtnText: "Update",
    },
    VIEW: {
        headingText: "View User",
    },
};

export default ACCESS_MODAL_CONFIG;
